import { render, staticRenderFns } from "./allocation-checkbox.vue?vue&type=template&id=6b0e7f8a"
import script from "./allocation-checkbox.vue?vue&type=script&lang=js"
export * from "./allocation-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports